var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../../service/api.service';
import { ContentBaseService } from '../../../../../component/base/contentbase.service';
import { Option } from '../../../../../models/option/option';
var KtsConstructionClassificationService = /** @class */ (function (_super) {
    __extends(KtsConstructionClassificationService, _super);
    function KtsConstructionClassificationService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.options = {};
        return _this;
    }
    KtsConstructionClassificationService.prototype.setInit = function (targetComponents) {
        var _this = this;
        if (targetComponents === void 0) { targetComponents = []; }
        if (targetComponents.length === 0) {
            this.options = {};
        }
        else {
            targetComponents.filter(function (comp) { return typeof _this.options[comp] !== 'undefined'; }).forEach(function (comp) { return _this.options[comp] = {}; });
        }
    };
    KtsConstructionClassificationService.prototype.setOption = function (compName, key, id, options) {
        var option = new Option();
        if (id && options.length > 0) {
            for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
                var opt = options_1[_i];
                if (opt.code.toString() === id.toString()) {
                    option = opt;
                    break;
                }
            }
        }
        if (typeof this.options[compName] === 'undefined') {
            this.options[compName] = {};
        }
        this.options[compName][key] = option;
    };
    KtsConstructionClassificationService.prototype.getOption = function (compName, key) {
        return this.options[compName] && this.options[compName][key] ? this.options[compName][key] : new Option();
    };
    KtsConstructionClassificationService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsConstructionClassificationService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsConstructionClassificationService;
}(ContentBaseService));
export { KtsConstructionClassificationService };
//# sourceMappingURL=construction-classification.service.js.map